export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <span className="text-background-50 font-bold text-base font-heading">88</span>
              </div>
              <span className="text-background-50 font-bold text-lg font-heading">88影视网</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              88影视网致力于为全球影迷提供高清影视在线观看服务，涵盖高清电影电视剧、超清影视播放等丰富内容。画质清晰、播放流畅，打造极致的高清视频网站观影体验。
            </p>
          </div>

          <div>
            <h3 className="text-background-50 font-heading font-semibold mb-4 text-sm">快速导航</h3>
            <ul className="space-y-2.5">
              <li><a href="#hero" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">首页</a></li>
              <li><a href="#updates" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">影视快讯</a></li>
              <li><a href="#ranking" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">热播榜单</a></li>
              <li><a href="#index" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">专题合集</a></li>
              <li><a href="#faq" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">常见问题</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-background-50 font-heading font-semibold mb-4 text-sm">影视分类</h3>
            <ul className="space-y-2.5">
              <li><span className="text-sm text-background-400">动作片</span></li>
              <li><span className="text-sm text-background-400">科幻片</span></li>
              <li><span className="text-sm text-background-400">悬疑片</span></li>
              <li><span className="text-sm text-background-400">喜剧片</span></li>
              <li><span className="text-sm text-background-400">国产剧</span></li>
            </ul>
          </div>

          <div>
            <h3 className="text-background-50 font-heading font-semibold mb-4 text-sm">合作伙伴</h3>
            <p className="text-sm text-background-500 italic">合作伙伴信息即将上线，敬请期待。</p>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 88影视网 版权所有 | 高清影视在线观看平台
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-500">关注我们</span>
            <a href="#" className="w-8 h-8 flex items-center justify-center text-background-400 hover:text-primary-400 transition-colors cursor-pointer"><i className="ri-wechat-line text-lg"></i></a>
            <a href="#" className="w-8 h-8 flex items-center justify-center text-background-400 hover:text-primary-400 transition-colors cursor-pointer"><i className="ri-weibo-line text-lg"></i></a>
            <a href="#" className="w-8 h-8 flex items-center justify-center text-background-400 hover:text-primary-400 transition-colors cursor-pointer"><i className="ri-bilibili-line text-lg"></i></a>
          </div>
        </div>
      </div>
    </footer>
  );
}